/**
 * @generated SignedSource<<ab239ccc923ddec6f98c58efc235717b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NodeTagList_LearnOpportunityRootStructureDefinitionFragment$data = {
  readonly tags: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"NodeTag_TagFragment">;
  }>;
  readonly " $fragmentType": "NodeTagList_LearnOpportunityRootStructureDefinitionFragment";
};
export type NodeTagList_LearnOpportunityRootStructureDefinitionFragment$key = {
  readonly " $data"?: NodeTagList_LearnOpportunityRootStructureDefinitionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"NodeTagList_LearnOpportunityRootStructureDefinitionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NodeTagList_LearnOpportunityRootStructureDefinitionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Tag",
      "kind": "LinkedField",
      "name": "tags",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NodeTag_TagFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "LearnOpportunityRootStructureDefinition",
  "abstractKey": null
};

(node as any).hash = "1e4166918dc7b48050be138e752aaca4";

export default node;
